import $ from 'jquery'
import {ChartType} from '../../constants'
import TableDefinitionBuilder from './TableDefinitionBuilder'

export default class SimpleTableDefinitionBuilder extends TableDefinitionBuilder {
    constructor(chartType, valueFormatter, categoryFormatter, grandTotalValue) {
        super(chartType, valueFormatter, categoryFormatter, grandTotalValue)
    }

    getTable(dataRows, margins, tableStyle) {
        return this.placeholderCtrs.simpleTable(dataRows, margins, tableStyle)
    }


    getDataRows(pageDataList, showDataList, showPercentsList, tableValueStyles, rowDataMaxLens) {
        const rows = []
        for (let i = 0; i < pageDataList.length; i++) {
            const isSecond = i % 2 !== 0 //!counter starts with 0
            if (!$.isEmptyObject(pageDataList[i].category)) {
                const row = this._getDataRow(pageDataList[i], showDataList, showPercentsList, tableValueStyles, rowDataMaxLens, isSecond)
                rows.push(row)
            }
        }
        return rows
    }


    /**
     * Create data cell element depends parameters or chartType
     * If chartType is pie, than cell will contains color rectangle
     * @param cellValue - object of value for one cell
     * @param showDataList - if need show values
     * @param showPercentsList - if need show percents
     * @param tableValueStyles - styles for table cell
     * @param rowDataMaxLens - max len in chars of value string (name + value)
     * @param isSecond - second row or not
     * @returns {*}
     * @private
     */
    _getDataRow = function(cellValue, showDataList, showPercentsList, tableValueStyles, rowDataMaxLens, isSecond) {
        const isValueAndPercentsCell = showDataList && showPercentsList
        let maxDataRowLen = isValueAndPercentsCell ? rowDataMaxLens.valueAndPercents : rowDataMaxLens.valueOrPercents // get max len for current parameters

        const value = this.chartType === ChartType.PIE_CHART ? cellValue.value : cellValue.value.total
        const formattedValue = this.valueFormatter(value)
        const formattedPercent = this._getPercentValue(value)

        maxDataRowLen -= showDataList ? (formattedValue.toString().length - 3) : formattedPercent.length // substrate len of value without 3 chars (:dd or .dd) or percent length
        const formattedCategory = this.categoryFormatter(cellValue.category, maxDataRowLen)

        if (isValueAndPercentsCell) {
            return this.chartType === ChartType.PIE_CHART ?
                   this.templateCtrs.colorValuePercentRow(
                       cellValue.color,
                       formattedCategory,
                       formattedValue,
                       formattedPercent,
                       tableValueStyles,
                       isSecond,
                   ) :
                   this.templateCtrs.valuePercentRow(
                       formattedCategory,
                       formattedValue,
                       formattedPercent,
                       tableValueStyles,
                       isSecond,
                   )
        } else {
            const cellData = showDataList ? formattedValue : formattedPercent // percent or value
            return this.chartType === ChartType.PIE_CHART
                   ? this.templateCtrs
                         .colorValueRow(
                             cellValue.color,
                             formattedCategory,
                             cellData,
                             tableValueStyles,
                             isSecond)
                   : this.templateCtrs
                         .valueRow(
                             formattedCategory,
                             cellData,
                             tableValueStyles,
                             isSecond)
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/SimpleTableDefinitionBuilder.js